import React from 'react'
import { Dropdown } from 'react-bootstrap';

export default function CasePullDropdown(props) {
    const { dropDownButtons, casePull, casePullValue, regions, selectedRegion, disableCasePull, disableRegion, handleCasePull, handleInputChange } = props;
    return (
        <div className="d-flex align-items-center justify-content-left">
            <div className="case-pull-dropdown-wrap d-flex align-items-center justify-content-left">
                <Dropdown>
                    <Dropdown.Toggle variant="primary" data-testid="dropdown-casepull" id="dropdown-casepull-first" className="btn btn-outline-primary btn-dropdown-text case-pull-dropdown">{casePullValue}</Dropdown.Toggle>
                    <Dropdown.Menu>
                        {dropDownButtons.map((button, index) => {
                            return (
                                <Dropdown.Item
                                    key={`item_${index}`}
                                    id={`item_${button.value}`}
                                    data-testid={`dropdown-item-${button.value}`} 
                                    disabled={button.value !== 'region' && disableCasePull === button.value}
                                    className={`case-pull-option ${casePull === button.value ? 'selected' : ''}`}
                                    eventKey={button.value}
                                    onClick={() => handleCasePull(button.value)}>
                                    {button.label}
                                </Dropdown.Item>
                            )
                        })}
                    </Dropdown.Menu>
                </Dropdown>
            </div>

            {casePull === 'region' ?
                <div className="region-dropdown-wrap ms-3">
                    <Dropdown>
                        <Dropdown.Toggle variant="primary" data-testid="dropdown-regions" id="dropdown-regions" className="btn btn-outline-primary btn-dropdown-text">{selectedRegion}</Dropdown.Toggle>
                        <Dropdown.Menu>
                            {regions.map((region, index) => {
                                return (
                                    <Dropdown.Item
                                        key={`item_${index}`}
                                        id={`item_${region.name}`}
                                        data-testid={`dropdown-item-${region.name}`}
                                        disabled={disableRegion === region.name}
                                        className={`case-pull-option ${selectedRegion === region.name ? 'selected' : ''}`}
                                        eventKey={region.name}
                                        onClick={() => handleInputChange(region.name)}>
                                        {region.name}
                                    </Dropdown.Item>
                                )
                            })}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                : ''}
        </div>
    )
}
